import axios from 'axios';

/** Endpoints are supplied by the host app; no server paths are assumed. */
export function createCEOManagementApi({ endpoints = {}, sessionToken } = {}) {
  const headers = sessionToken ? { Authorization: `Bearer ${sessionToken}` } : undefined;
  const urlOf = (endpoint) => typeof endpoint === 'string' ? endpoint : endpoint?.url;
  const methodOf = (endpoint) => typeof endpoint === 'string' ? 'POST' : endpoint?.method || 'POST';
  const unpack = (response) => {
    const payload = response.data;
    if (payload?.status >= 400) throw new Error(payload.message || 'The server rejected this request.');
    return payload?.data ?? payload;
  };
  const loadManagement = endpoints.read ? async ({ signal }) => {
    const result = unpack(await axios.get(urlOf(endpoints.read), { signal, headers, timeout: 30000 }));
    if (!result || typeof result !== 'object' || !Array.isArray(result.staff) || !Array.isArray(result.territories)) {
      throw new Error('Organization data must include staff and territories arrays.');
    }
    return result;
  } : null;
  const mutate = (endpoint) => endpoint ? async (payload) => unpack(await axios({ method: methodOf(endpoint), url: urlOf(endpoint), data: payload, headers, timeout: 30000 })) : null;
  return {
    loadManagement,
    onAssignTerritory: mutate(endpoints.assign),
    onTransferStaff: mutate(endpoints.transfer),
    onSetTarget: mutate(endpoints.target),
  };
}
